// © 2013 - 2022 Tinder, Inc., ALL RIGHTS RESERVED

import React, { forwardRef } from 'react';

import { TextFieldProps, TextFieldElement } from './types';

import TextFieldLabel from './TextFieldLabel';
import TextFieldInput from './TextFieldInput';

const TextField: React.ForwardRefRenderFunction<TextFieldElement, TextFieldProps> = (
  props,
  ref
) => {
  const {
    variant,
    id,
    label,
    labelColor,
    labelColorError,
    hasError,
    minHeight,
    maxHeight,
    minRows,
    maxRows,
    ...restProps
  } = props;

  return (
    <>
      {label ? (
        <TextFieldLabel
          variant={variant}
          id={id}
          hasError={hasError}
          color={labelColor}
          colorError={labelColorError}
        >
          {label}
        </TextFieldLabel>
      ) : null}
      <TextFieldInput
        variant={variant}
        id={id}
        hasError={hasError}
        minHeight={minHeight}
        maxHeight={maxHeight}
        minRows={minRows}
        maxRows={maxRows}
        {...restProps}
        ref={ref}
      />
    </>
  );
};

export default forwardRef(TextField);
